import { MbscCalendarEvent } from '@mobiscroll/react';
import { DateTime } from 'luxon';

import { decimalToDuration } from '@work4all/components';

import { TimeTracking } from '@work4all/models/lib/Classes/TimeTracking.entity';

export const calculateDuration = (event: MbscCalendarEvent) => {
  const start = DateTime.fromJSDate(event.start as Date).startOf('minute');
  const end = DateTime.fromJSDate(event.end as Date)
    .startOf('minute')
    .set({
      year: start.year,
      month: start.month,
      day: start.day,
    });
  const amount = (event.original as TimeTracking)?.amount;

  const duration = event.allDay
    ? calculateDurationFromHours()
    : calculateDurationFromStartEnd();

  function calculateDurationFromHours() {
    return decimalToDuration(amount);
  }

  function calculateDurationFromStartEnd() {
    return end.diff(start, ['hours', 'minutes']);
  }

  return duration;
};
